import { render, staticRenderFns } from "./p_tech017.vue?vue&type=template&id=561748fa&scoped=true&"
import script from "./p_tech017.vue?vue&type=script&lang=js&"
export * from "./p_tech017.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561748fa",
  null
  
)

export default component.exports